import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

/**
 * StartRow:
 *  - A Row Component that render the Input Nodes of
 *    DesignSlide Second.
 */
export function StartRow(props) {
  const renderComponent = (component, key) =>
    React.cloneElement(props.nodeHolder, {
      key: key,
      positionId: component.id,
      droppedId: component.droppedId,
      image: component.image,
      modal: component.modal,
      title: component.title,
    });

  const rowClass = () => {
    const nodeLength = props.nodeComponents.length;
    return `jointStartRow jointStartRow-${nodeLength}`;
  };

  return (
    <div className="startRow">
      <div className={rowClass()}>
        {props.nodeComponents.map(renderComponent)}
      </div>
    </div>
  );
}

StartRow.propTypes = {
  /**
   * Unique Id for the node
   */
  nodeId: PropTypes.number.isRequired,
  /**
   * List Of components to be displayed in Row
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      droppedId: PropTypes.number,
      image: PropTypes.string,
      title: PropTypes.string,
      modal: PropTypes.object,
    })
  ).isRequired,
  /**
   * NodeHolder Component that will render placeholder and dropped component
   */
  nodeHolder: PropTypes.element.isRequired,
};
